export const LOGIN = () => `/login`;
export const REGISTER = () => `/register`;
export const CHANGE_PASSWORD = () => `/change-password`;
export const FORGOT_PASSWORD = () => `/forgot-password`;
